export default ({ env }) => {
  console.log(`%c🚀 Deployed AM2 Commit: ${env.GIT_HASH}: ${env.GIT_COMMIT_MESSAGE} - ${env.GIT_COMMIT_TIMESTAMP}`, 'color: cyan; font-weight: bold;')
};
